import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FaHome,
  FaUser,
  FaProductHunt,
  FaCog,
  FaBars,
  FaTimes,
  FaTachometerAlt,
  FaClipboardList,
  FaChartBar,
  FaBox,
  FaGift,
  FaStar,
  FaFire,
  FaTags,
  FaImage,
  FaSignOutAlt,
  FaMapMarkerAlt
} from "react-icons/fa";
import { Button, Nav } from "react-bootstrap";

const Sidebar = ({ isCollapsed, setIsCollapsed }) => {
  const location = useLocation(); // Get current route to highlight active link
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear admin authentication from localStorage
    localStorage.removeItem("adminAuthenticated");
    localStorage.removeItem("adminEmail");
    
    // Dispatch custom event to notify AdminProtectedRoute
    window.dispatchEvent(new Event("adminAuthChange"));
    
    // Redirect to admin login page
    navigate("/admin");
  };

  const menuItems = [
    { id: 1, title: "Users", icon: <FaUser />, path: "/admin/users" },
    { id: 2, title: "Technicians", icon: <FaUser />, path: "/admin/technicians" },
    { id: 3, title: "Banner", icon: <FaImage />, path: "/admin/banner" }, 
    { id: 6, title: "Categories", icon: <FaTags />, path: "/admin/categories" },   
    { id: 4, title: "Content1", icon: <FaTags />, path: "/Admin/AdminContent1" },   
    // { id: 3, title: "Content2", icon: <FaTags />, path: "/Admin/AdminContent2" },
    { id: 7, title: "Brands", icon: <FaBox />, path: "/admin/Brands" },
    { id: 5, title: "Products", icon: <FaProductHunt />, path: "/admin/products" },
    { id: 14, title: "Embroidery Designs", icon: <FaImage />, path: "/admin/embroidery-designs" },
    { id: 15, title: "Blogs", icon: <FaClipboardList />, path: "/admin/blogs" },
    // { id: 5, title: "AboutUs", icon: <FaBox />, path: "/admin/AdminAboutUs" },

  

    { id: 8, title: "OfferBanner", icon: <FaGift />, path: "/admin/OfferBanner" },
    { id: 9, title: "Reviews", icon: <FaStar />, path: "/admin/reviews" },
    // { id: 10, title: "Trending Products", icon: <FaFire />, path: "/admin/ServiceRequest" },
    { id: 11, title: "ServiceRequest", icon: <FaTags />, path: "/admin/ServiceRequest" },    
    { id: 13, title: "Locations", icon: <FaMapMarkerAlt />, path: "/admin/locations" },
    { id: 12, title: "Orders", icon: <FaClipboardList />, path: "/admin/orders" },
    // { id: 12, title: "Reports & Analytics", icon: <FaChartBar />, path: "/admin/reports" },
    // { id: 13, title: "Settings", icon: <FaCog />, path: "/admin/settings" },
    // { id: 14, title: "Banner", icon: <FaImage />, path: "/admin/banner" },

 
  ];

  return (
    <div className={`d-flex flex-column ${isCollapsed ? "collapsed" : ""}`} style={{ width: isCollapsed ? "80px" : "260px", height: "100vh", backgroundColor: "#61A5FA", color: "white", position: "fixed", top: 0, left: 0, transition: "width 0.3s ease-in-out", paddingTop: "20px", boxShadow: "2px 0 10px rgba(0, 0, 0, 0.2)", overflowY: "auto" }}>
      {/* Sidebar Title */}
      {!isCollapsed && <h3 className="sidebar-title text-center">Admin Panel</h3>}

      {/* Menu Items */}
      <Nav className="flex-column mt-3">
        {menuItems.map((item) => (
          <Nav.Link
            key={item.id}
            as={Link}
            to={item.path}
            className={`d-flex align-items-center p-2 ${location.pathname === item.path ? "active bg-light text-dark" : "text-white"}`}
            style={{ borderRadius: "5px", transition: "background 0.3s ease-in-out" }}
          >
            <span className="icon" style={{ fontSize: "20px", marginRight: isCollapsed ? "0" : "15px" }}>{item.icon}</span>
            {!isCollapsed && <span className="title">{item.title}</span>}
          </Nav.Link>
        ))}
      </Nav>

      {/* Logout Button */}
      <div style={{ marginTop: "auto", padding: "20px" }}>
        <Button
          variant="danger"
          onClick={handleLogout}
          className="w-100 d-flex align-items-center justify-content-center"
          style={{
            borderRadius: "5px",
            padding: "10px",
            backgroundColor: "#dc3545",
            border: "none",
            color: "white"
          }}
        >
          <FaSignOutAlt style={{ fontSize: "18px", marginRight: isCollapsed ? "0" : "10px" }} />
          {!isCollapsed && <span>Logout</span>}
        </Button>
      </div>
    </div>
  );
};

export default Sidebar;
